module.exports = __webpack_public_path__ + "static/media/cloudcom.a10f4149.png";